import { useDateFnsLocale } from '@if/core/date'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { type ReactNode } from 'react'

interface Props {
  children: ReactNode
}
/**
 * third party lib, except MUI Core and plugins translation, locale initialisation
 * MUI components translation needs to be set in the theme
 */
const LocaleProvider = ({ children }: Props) => {
  const { locale } = useDateFnsLocale()

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      {children}
    </LocalizationProvider>
  )
}

export default LocaleProvider
